// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { ProjectCommitteeInput } from './create-new-project-committees-input';

export interface UpdateProjectCommitteeInput {
  projectId: string;
  committeeId: string;
  committee: ProjectCommitteeInput;
}
